export const WEBSITE_INTERVAL = {
  WEEKLY: 7,
  MONTHLY: 30,
};

export const WEBSITE_INITIAL_REQUEST = {
  schedule: {
    interval: 0,
    enabled: false,
    period: 'days',
  },
  urls: [],
  exclude_urls: [],
  recursive: false,
  name: 'website',
  run_immediately: true,
  ml_uploader_type: 'customer',
  type: 'web_scrapper',
};

export const WEBSITE_INITIAL_REQUEST_V2 = {
  type: 'web_scrapper',
  name: 'website',
  url: '',
  schedule: {
    interval: 0,
    enabled: false,
    period: 'days',
  },
  run_immediately: true,
  // exclude_urls: [],
  // include_urls: [],
  // exclude_extensions: [],
  recursive: false,
  limit: 500,
  max_depth: 10,
};

export const TICKETS_INTERVAL = {
  WEEKLY: 7,
  MONTHLY: 30,
};

export const ZENDESK_TICKETS_INITIAL_REQUEST = {
  schedule: {
    interval: 0,
    enabled: false,
    period: 'days',
  },
  subdomain: '',
  auth_email: '',
  api_token: '',
  start_from: '',
  agents: [],
  name: '',
  run_immediately: true,
  ml_uploader_type: 'customer',
  type: 'zendesk_tickets',
};

export const FRESHDESK_TICKETS_INITIAL_REQUEST = {
  schedule: {
    interval: 0,
    enabled: false,
    period: 'days',
  },
  subdomain: '',
  api_key: '',
  start_from: '',
  // agents: [],
  name: '',
  ml_uploader_type: 'customer',
  run_immediately: true,
  type: 'freshdesk_tickets',
};

export const FILE_STATE = {
  UPLOADING: 'uploading',
  UPLOADED: 'uploaded',
  UPLOAD_ERROR: 'upload_error',
  DELETING: 'deleting',
  DELETE_ERROR: 'delete_error',
};
